import pRetry from "p-retry";
import { buildUserIdPayload, hasUserId } from '../utils/userIdPayload';

const requireUserId = (userId) => {
    if (!hasUserId(userId)) {
        throw new Error('Не удалось определить пользователя. Откройте приложение из MAX или Telegram заново.');
    }
};

export async function getContractsByID({ platform, userId }) {
    requireUserId(userId);
    return await pRetry(async () => {
        return await _getContractsByID({ platform, userId });
    }, {retries: 5});
}

export async function _getContractsByID({ platform, userId }) {
    requireUserId(userId);
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/auth/get_contracts`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildUserIdPayload(platform, userId))
    });

    const result = (await response.json())?.result;

    if (Array.isArray(result)) {
        return result
            .filter(contract => {
                if (platform === 'max') return String(contract.max_id) === String(userId);
                return String(contract.tg_id) === String(userId);
            })
            .map(contract => contract.contract_number);
    }

    return result;
}

export async function getUserInfoByContract({contract_number}) {
    return await pRetry(async () => {
        return await _getUserInfoByContract({contract_number});
    }, {retries: 5});
}

export async function _getUserInfoByContract({contract_number}) {
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/auth/get_contract_info`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            contract_number: contract_number
        })
    });

    return {...(await response.json())?.result, is_kz: contract_number.includes("KZ")};
}

export async function getTemplatesByContract({contract_number}) {
    return await pRetry(async () => {
        return await _getTemplatesByContract({contract_number});
    }, {retries: 5});
}

export async function _getTemplatesByContract({contract_number}) {
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/template/get_templates`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            contract_number: contract_number
        })
    });

    return (await response.json())?.result;
}

export async function getPackagesByID({ platform, userId, contract_number }) {
    return await pRetry(async () => {
        return await _getPackagesByID({ platform, userId, contract_number });
    }, { retries: 5 });
}

export async function _getPackagesByID({ platform, userId, contract_number }) {
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/tracking/get_packages`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...buildUserIdPayload(platform, userId),
            contract_number
        })
    });

    return await response.json();
}


export async function create_feedback({ platform, userId, rating, feedback }) {
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/feedback/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...buildUserIdPayload(platform, userId),
            rate: rating,
            comment: feedback
        })
    });

    return (await response.json())?.result;
}

export async function callback_pretense({ platform, userId, meta, session }) {
    return await pRetry(async () => {
        return await _callback_pretense({ platform, userId, meta, session });
    }, {retries: 5});
}

export async function _callback_pretense({ platform, userId, meta, session }) {
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/pretense/callback_pretense`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...buildUserIdPayload(platform, userId), meta,
            session
        })
    });
}

export async function getProfile({ platform, userId }) {
    return await pRetry(async () => {
        const response = await window.fetch(
            `${process.env.REACT_APP_API_URL}/api/auth/get_profile`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(buildUserIdPayload(platform, userId)),
            },
        );
        return (await response.json())?.result;
    }, { retries: 5 });
}

export async function updateProfile({ platform, userId, firstName, lastName, middleName, phoneNumber, username, lang }) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/update_profile`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...buildUserIdPayload(platform, userId),
                first_name: firstName,
                last_name: lastName,
                middle_name: middleName,
                phone_number: phoneNumber,
                username: username,
                lang: lang,
            }),
        },
    );
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data?.message || data?.detail || 'Ошибка обновления профиля');
    }
    return (await response.json())?.result;
}

export async function getMaxDeepLink({ tgId }) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/max_deep_link`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tg_id: String(tgId) }),
        },
    );
    return (await response.json())?.result;
}
